module.exports = __webpack_public_path__ + "media/assets/images/magnifying-glass-42d9c54b5cdfeaccb5ceecf3eb4aea05.svg";